import { Drawer } from '@mui/material'
import { BasePathProvider } from 'components/Providers'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { search as searchAttendanceSettings } from 'store/attendance/attendance-settings'
import { getIncidentItems } from 'store/discipline/incident'
import AttendanceSettingsList from './List'
import AttendanceSettingsForm from './Form'

export default function AttendanceSettings() {
  const dispatch = useDispatch()
  const [selected, setSelected] = useState(null)

  const basePath = '/attendance/settings'

  const attendanceStatus = useSelector(state => state.attendance.attendanceSettings.list)
  const incidentItems = useSelector(state => state.discipline.disciplineIncident.incidentItems)

  useEffect(() => {
    if (!attendanceStatus) dispatch(searchAttendanceSettings())
  }, [Boolean(attendanceStatus)])

  useEffect(() => {
    if (!incidentItems) dispatch(getIncidentItems())
  }, [Boolean(incidentItems)])

  const handleClose = () => {
    setSelected(null)
  }

  return (
    <BasePathProvider value={basePath}>
      <AttendanceSettingsList
        rows={attendanceStatus}
        incidentItems={incidentItems}
        setSelected={setSelected}
      />

      <Drawer
        PaperProps={{
          sx: {
            width: 600,
          },
        }}
        open={Boolean(selected)}
        anchor="right"
        onClose={handleClose}
      >
        {selected && <AttendanceSettingsForm selected={selected} onClose={handleClose} />}
      </Drawer>
    </BasePathProvider>
  )
}